var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA2ElectricalProject(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 18l-6-6H9v52h58V18H31zm32 42H13V22h50v38zM40.68 42H26l13.43-16.62L42.54 28l-8.22 10h15L37.41 52.3l3.5 3.7H31v-9.9l3.55 3.35L40.68 42z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A2_Electrical_Project.81ebe409.svg";
export { SvgA2ElectricalProject as ReactComponent };